<template>
    <div class="inner-wrapper">
   <!--<div class="page-title">
      <h1 class="float-left">Edit Task</h1>
   </div>-->
   <div class="alert alert-danger alert-dismissible" v-if="errorMessage !=null">
                    <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
                    <strong class="success_msg">{{errorMessage}}</strong>
                </div>
                <div class="alert alert-success succ_msg" v-if="successMessage">
                    <strong class="success_msg">{{successMessage}}</strong>
                </div>
             <div v-if="commonErrors.length !=0" class="alert alert-danger alert-dismissible">
                <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
                <ul>
                    <li v-for="(v, k) in commonErrors" :key="k">
                    <p v-for="error in v" :key="error" class="text-sm">
                    {{ error }}
                    </p>
                    </li>
                </ul>
            </div>
<ValidationObserver v-slot="{ handleSubmit }">
   <form @submit.prevent="handleSubmit(save)" id="addCustomerForm" name="addCustomerForm" method="post">
      <div class="new-rfq">
        <div class="mb-3 row">

            <div class="col-lg-12 col-md-12">
                <div class="card panel create-box">

                    <div class="card-body">

                        <div class="row">
                            <div class="col-lg-4 col-md-4">
                                <div class="form-group flex-fill">
                                    <label>Task Name</label>
                                    <validation-provider rules="required" v-slot="{ errors }">
                                        <input type="text" class="form-control" placeholder=""  v-model="form.title"  id="product_num" name="product_num" />
                                        <span class="error">{{ errors[0] }}</span>
                                    </validation-provider>
                                </div>
                            </div>
                            <div class="col-lg-12 col-md-12">
                                <div class="form-group flex-fill">
                                    <label>Description</label>
                                    <textarea class="form-control" name="company_name" placeholder="" v-model="form.description"></textarea>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-4">
                                <div class="form-group flex-fill">
                                    <label>Assined to</label>
                                    <v-select label="name" v-model="form.assign_to" :filterable="false" :options="options" :reduce="(option) => option.id" @search="onSearch">
                                        <template slot="no-options">
                                        Search User
                                        </template>
                                        <template slot="option" slot-scope="option">
                                        <div class="d-center">
                                            {{ option.name }}
                                            </div>
                                        </template>
                                        <template slot="selected-option" slot-scope="option">
                                        <div class="selected d-center">
                                            {{ option.name }}
                                        </div>
                                        </template>
                                    </v-select>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-4">
                                <div class="form-group flex-fill">
                                    <label for="pwd">Due Date:</label>
                                    <template>
                                    <date-range-picker :ranges=false :autoApply="autoApply"  :showDropdowns="showDropdowns" v-model="dateRange" :singleDatePicker="singleDatePicker" @update="updateValues">
                                    </date-range-picker>
                                    </template>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-4">
                                <div class="form-group flex-fill">
                                    <label>Priority</label>
                                    <validation-provider rules="required" v-slot="{ errors }">
                                    <v-select label="priority_name" v-model="form.priority"  :options="taskPriority" :reduce="(option) => option.id" >

                                        <template slot="option" slot-scope="option">
                                        <div class="d-center">
                                            {{ option.priority_name }}
                                            </div>
                                        </template>
                                        <template slot="selected-option" slot-scope="option">
                                        <div class="selected d-center">
                                            {{ option.priority_name }}
                                        </div>
                                        </template>
                                    </v-select>
                                    <span class="error">{{ errors[0] }}</span>
                                    </validation-provider>
                                    <!-- <select v-model="form.priority" class="form-control">
                                        <option value="" >Select Priority</option>
                                        <template v-for="priority in taskPriority">
                                            <option value="{{priority.id}}">Select Priority</option>
                                        </template>
                                    </select> -->
                                </div>
                            </div>

                            <div class="form-group-up">
                                <div class="form-group flex-fill">
                                    <div  v-cloak @drop.prevent="addFile" @dragover.prevent class="files task-files">
                                    <input type="file" name="csv_file" v-on:change="handleFileUpload" ref="csv_file" style="border: none;">
                                        <h2>Files to Upload (Drag them over)</h2>

                                        <ul>
                                            <li v-for="file in files">
                                            {{ file.name }}  <button @click="removeFile(file)" title="Remove">X</button>
                                            </li>
                                        </ul>


                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="btnrow text-right">
                            <router-link :to="{name: 'viewCustomers'}" class="btn btn-danger me-1">Discard</router-link>
                            <button type="submit" :disabled="submitted" class="btn btn-primary" id="save_customer_btn">Save</button>
                            <!-- <a href="#" class="btn custom-btn ml-3">Save</a> -->
                        </div>
                    </div>

                </div>




            </div>
        </div>

      </div>
   </form>
</ValidationObserver>
   <footer class="footer">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-sm-6">
                        2022 © Superb.
                    </div>
                    <div class="col-sm-6">
                        <div class="text-right d-none d-sm-block">
                            All Rights Reserved.
                        </div>
                    </div>
                </div>
            </div>
        </footer>
</div>
</template>
<script>
import { ValidationObserver,ValidationProvider, extend,validate  } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import {mapState, mapActions, mapGetters} from 'vuex';
import moment from 'moment';
import axios from "axios";
extend('required', {
  ...required,
  message: 'This field is required'
});
extend('positive', value => {

  if (value >= 0) {
    return true;
  }
  return 'Please enter only number';
});
export default {
    name: "TaskEdit",
    components: {
        ValidationProvider,ValidationObserver
    },
    created() {
        if(localStorage.getItem('token')){
             console.log("token "+localStorage.getItem('token'));
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
        }
        this.getCustomer();
        this.setSuccessMessage(null);
    },
    data(){
        return {
            files:[],
            selected:[],
            options:[],
            taskPriority:[],
            inlineDatePicker:true,
            autoApply:false,
            singleDatePicker:true,
            showDropdowns:true,
            inlineDateRange:{
                startDate: moment().subtract(29, 'days').toDate(),
                endDate: moment().toDate(),
                ranges: false
            },
            dateRange: {
               startDate: moment().subtract(29, 'days').toDate(),
               endDate: moment().toDate(),
               //ranges:false
            },
            editorConfig: {
                // The configuration of the editor.
            },
            options:[],
            form: {
                title:null,
                assign_to:null,
                due_date:null,
                customer_id:null,
                description:null,
                priority:null,
            },
            submitted: false
        }
    },
    methods: {
        ...mapActions([
            'setCommonErrors',
            'setErrorMessage',
            'setSuccessMessage',
            'setCustomers',
            'setCustomerLoading'
        ]),
        handleFileUpload(){
            this.files.push(this.$refs.csv_file.files[0]);
            //this.csv_file = this.$refs.csv_file.files[0];
        },
        addFile(e) {
            let droppedFiles = e.dataTransfer.files;
            if(!droppedFiles) return;
            // this tip, convert FileList to array, credit: https://www.smashingmagazine.com/2018/01/drag-drop-file-uploader-vanilla-js/
            ([...droppedFiles]).forEach(f => {
                this.files.push(f);
            });
            console.log("files ",this.files);
        },
        removeFile(file){
            this.files = this.files.filter(f => {
                return f != file;
            });
        },
        updateValues(){
            console.log("Start DAte",moment(this.dateRange.startDate).format('YYYY-MM-DD'));
            console.log("Start endDate",moment(this.dateRange.endDate).format('YYYY-MM-DD'));
            this.form.due_date = moment(this.dateRange.startDate).format('YYYY-MM-DD');
        },
         onSearch(search, loading) {
            if(search.length) {
                loading(true);
                this.search(loading, search, this);
            }
        },
        search(loading, search, vm) {
            let self = this;
            this.setCustomerLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.post(window.route('tasks.search',{search: search} ), {

                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
            .then(({ data }) => {
                console.log("DATA ",data);
                if(data.errors){
                    console.log("error ",data);
                    self.setCommonErrors(data.errors);
                } else if(data.errorMessage){
                    self.setErrorMessage(data.errorMessage);
                } else {
                    let customer = [];
                    let allData =  data.data.data
                    console.log("Length",allData,allData.length);
                    vm.options = data.data.data;

                   loading(false);

                }
            })
            .catch((error) => {
                self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

            })
            .finally(() => {
                self.setCustomerLoading(false);

            });
        },
        getCustomer() {
            let self = this;
            this.setCustomerLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            //this.setSuccessMessage(null);
            return axios.get(window.route('tasks.show', {id: this.$route.params.id}), {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({ data }) => {
                    if(data.errors){
                        self.setCommonErrors(data.errors);
                    } else if(data.errorMessage){
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        this.taskPriority = data.task_priority;
                        this.form.title = data.data.title,
                        this.form.due_date = data.data.due_date;
                        this.dateRange.startDate = data.data.due_date;
                        this.dateRange.endDate = data.data.due_date;
                        this.form.description = data.data.details;
                        this.form.priority = data.data.priority_id;
                         if(data.data.assignee_name){
                            this.form.assign_to = data.data.assignee_name.id;
                            this.options = [
                                {
                                id:data.data.assignee_name.id,
                                name:data.data.assignee_name.name
                                }
                            ];
                         }
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setCustomerLoading(false);

                });
        },
        save() {

            this.submitted = true;
            let self = this;
            this.setCustomerLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            let formData = new FormData();
            this.files.forEach((f,x) => {
                formData.append('file[]', f);
            });
            formData.append('title', this.form.title);
            formData.append("_method", "PUT")
            formData.append('assign_to', this.form.assign_to);
            formData.append('due_date', this.form.due_date);
            formData.append('description', this.form.description);
            formData.append('priority', this.form.priority);

            return axios.post(window.route('tasks.update', {id: this.$route.params.id}), formData, {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                },
                headers: {
                        'Content-Type': 'multipart/form-data'
                    },
            })
                .then(({ data }) => {
                    if(data.errors){
                        self.setCommonErrors(data.errors);
                    } else if(data.errorMessage){
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        self.setSuccessMessage("Task Updated successfully.");
                        console.log(data.data);
                       // self.getCustomer();
                        setTimeout(() => {
                            self.setErrorMessage(null);
                            self.setSuccessMessage(null);
                            self.$router.push({ name: 'viewTasks' });
                        }, 3500);

                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    this.submitted = false;
                    self.setCustomerLoading(false);

                });
        }
    },
    computed: {
        ...mapState([
            'userState'
        ]),
        ...mapGetters([
            'isAuth',
            'getAuthUser',
            'commonErrors',
            'errorMessage',
            'successMessage',
            'customers',
            'customersLoading'
        ])
    }
}
</script>

<style scoped>

</style>
